import { PosType } from './location.types';

/** A POS from our list, or one we do not integrate with ("I use a different POS"). */
export const OTHER_POS = 'other';
export type PosChoice = PosType | typeof OTHER_POS;

/**
 * What a partner told us about one location: whether it runs a POS, which one, which
 * marketplaces it sells on, and whether they granted vGrubs access to each. A declaration,
 * not a connection: our team connects the POS and marketplaces afterwards, from this.
 */
export type IntegrationAccessPos = {
  type: PosChoice;
  /** The vGrubs account the partner adds in the POS; computed by the server. */
  accessEmail: string;
  accessGranted: boolean;
  accessGrantedAt: string | null;
  note: string | null;
};

export type IntegrationAccessProvider = {
  menuProviderId: number;
  name: string;
  image: string | null;
  /** The Manage Providers marketplace (`ubereats`, `nabe`, ...); null on a legacy row. */
  type?: string | null;
  /** Computed by the server and frozen when the provider is selected. */
  accessEmail: string;
  /** The marketplace asks for a password when the partner creates our user (Grubhub). */
  requiresPassword: boolean;
  /** Partner only, and only when `requiresPassword`; admins get `null` and reveal it on click. */
  password: string | null;
  hasPassword: boolean;
  portalUrl: string | null;
  portalLabel: string | null;
  accessGranted: boolean;
  accessGrantedAt: string | null;
  note: string | null;
};

export type IntegrationAccess = {
  /** `null` until the onboarding is completed. */
  locationId: number | null;
  incompleteLocationId: number | null;
  /** `null` = the partner has not answered "Do you use a POS system?" yet. */
  usesPos: boolean | null;
  /** `null` when `usesPos` is false or null, or when "Yes" but no POS picked yet. */
  pos: IntegrationAccessPos | null;
  /** In selection order. */
  providers: IntegrationAccessProvider[];
  updatedAt: string | null;
};

/**
 * Which route family to talk to. Onboarding works on the IncompleteLocation (the id the onboarding
 * screens already send to menu-providers); Settings and admin on the Location that exists after
 * `complete`. Same handlers and shape behind both.
 */
export type IntegrationAccessScope =
  | { incompleteLocationId: number | string }
  | { locationId: number | string };

export type UpdateIntegrationPosBody = {
  usesPos: boolean;
  /** Omit to keep the current POS; `null` clears it (back to the picker). */
  posType?: PosChoice | null;
};

/** Omit `note` to keep the stored one; an empty string clears it. At most 2000 characters. */
export type IntegrationAccessNoteBody = {
  note?: string;
};

export type IntegrationProviderPasswordResponse = {
  menuProviderId: number;
  password: string;
};
